import { useUpdateGroupModal } from "@/features/update-group"
import { RoleType } from "@/shared/api/users"
import { FC } from "react"

interface CreateGroupProps {
    role: RoleType
    onCreate?: () => void
}

export const CreateGroup: FC<CreateGroupProps> = ({ role, onCreate }) => {
    const { openCreateGroupModal } = useUpdateGroupModal()
    
    return (
        <button onClick={() => openCreateGroupModal(role, onCreate)} className="filter_button !w-fit">
            Создать группу
        </button>
    )
}